import { AppHeaderAction } from '@/components/AppHeader/AppHeaderAction';
import { useLayoutEffect } from 'react';
import { StyleSheet, View } from 'react-native';
import { useSentenceSetContext } from '@/contexts/SentenceSetContext/useSentencesetContext';
import { useContinueToSetDetails } from '@/hooks/useContinueToSetDetails';
import { useSetEditorCancel } from '@/hooks/useSetEditorCancel';
import { SecondHeader } from '@/components/SecondHeader';
import { Icon } from '@/components/Icon';
import { StackScreenProps } from '@react-navigation/stack';
import { TherapistStackParamList } from '@/navigations/TherapistStack';

type HeaderProps = {
  props: StackScreenProps<TherapistStackParamList, 'SentenceSet'>;
};

const styles = StyleSheet.create({
  header: {
    flexDirection: 'column',
    zIndex: 1,
  },
});

export function Header({ props }: HeaderProps) {
  const {
    apiKeyName,
    setId,
    editData,
    patientId,
    dynamicName,
    selectedData,
    dataKeyName,
    term,
    termType,
    handleOuterState,
    tags,
    template,
  } = useSentenceSetContext();
  const noSentencesSelected = !(selectedData ?? []).length;

  const { continueToDetails, hasPreviousStep } = useContinueToSetDetails({
    apiKeyName,
    items: selectedData ?? [],
    dataKeyName,
    dynamicName,
    patientId,
    setId,
    editData,
    template,
  });

  const cancel = useSetEditorCancel(props.route.params.flow, patientId);

  useLayoutEffect(() => {
    props.navigation.setOptions({
      headerLeft: hasPreviousStep
        ? () => (
            <AppHeaderAction
              primary
              onPress={() => props.navigation.goBack()}
              icon={<Icon name="chevronLeft" scale={1.2} />}
              text="Zurück"
            />
          )
        : undefined,
      headerRight: () => (
        <View style={{ gap: 30, flexDirection: 'row' }}>
          <AppHeaderAction
            primary
            onPress={cancel}
            icon={<Icon name="close" scale={1.2} />}
            text="Abbrechen"
          />
          <AppHeaderAction
            primary
            disabled={noSentencesSelected}
            onPress={continueToDetails}
            icon={<Icon name="chevronRight" />}
            text="Weiter"
          />
        </View>
      ),
    });
  }, [noSentencesSelected, continueToDetails, hasPreviousStep, cancel]);

  return (
    <View style={styles.header}>
      <SecondHeader
        term={term}
        termType={termType}
        changeOuterState={handleOuterState}
        tags={tags ?? []}
        type="sentence"
      />
    </View>
  );
}
